import { useTranslation } from 'react-i18next';

import { Header } from '@pentabd/ui';
import { IconFileSearch02 } from '@pentabd/icons';

export function PunishmentHistoryListPageHeader() {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconFileSearch02 fill="dark" size="20" />,
    },
    {
      label: t('PUNISHMENT_HISTORY_LIST.HEADING'),
    },
  ];

  const headerText = {
    header: t('PUNISHMENT_HISTORY_LIST.HEADING'),
    subHeader: t('PUNISHMENT_HISTORY_LIST.DESCRIPTION'),
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
}
